import {
  IconMembership,
  IconTerracedHouse,
  TabBar,
  TabItem,
  useIsMobile,
  getUrlWithProtocol,
  IconLocationHome,
  IconLocationAway,
} from '@bbl-digital/snorre-v2'
import { useAppSelector } from 'shared/store/store'
import { useHistory } from 'react-router'
import { navigationBreakpoint } from 'shared/constants/styles'
import {
  getBblDisplayNames,
  getBblUrls,
  isForkjopActive,
  isMypageActive,
} from 'shared/store/bbl/selectors'
import { isUserMember } from 'shared/store/user/selectors'
import { isBate } from 'shared/utils/theme'
import { getPreemptionUrl } from 'shared/utils/url'

const MobileTabs = () => {
  const hasPreemption = useAppSelector(isForkjopActive)
  const hasMypage = useAppSelector(isMypageActive)
  const isMember = useAppSelector(isUserMember)
  const urls = useAppSelector(getBblUrls)
  const history = useHistory()
  const isMobile = useIsMobile(navigationBreakpoint)
  const { myPageShort, portalShort } = useAppSelector(getBblDisplayNames)

  const isReactNativeApp = !!window.ReactNativeWebView

  const goToCard = () => {
    if (!urls?.myPage) return
    if (isBate() && isReactNativeApp) {
      window.location.href = 'bate://mitt-medlemskap'
      return
    }
    const path = isBate() ? 'mitt-medlemskap' : 'medlemskort'
    window.location.href = getUrlWithProtocol(`${urls.myPage}/${path}`)
  }

  const goToPortal = () => {
    history.push('/')
  }

  const goToMypage = () => {
    if (!urls?.myPage) return
    if (isBate() && isReactNativeApp) {
      window.location.href = 'bate://'
      return
    }
    window.location.href = getUrlWithProtocol(urls.myPage)
  }

  const goToPreemption = () => {
    window.location.href = getUrlWithProtocol(getPreemptionUrl())
  }

  if (!isMobile) return null
  if ((!isMember || !hasMypage) && !hasPreemption && !urls?.myPage) return null

  return (
    <TabBar>
      {isMember && hasMypage && (
        <TabItem
          text="Medlemsbevis"
          icon={<IconMembership colorVariant="currentColor" />}
          active={false}
          onClick={goToCard}
        />
      )}
      {urls?.myPage && (
        <TabItem
          text={myPageShort}
          icon={<IconLocationHome colorVariant="currentColor" />}
          active={false}
          onClick={goToMypage}
        />
      )}
      <TabItem
        text={portalShort}
        icon={<IconLocationAway colorVariant="currentColor" />}
        active
        onClick={goToPortal}
      />
      {hasPreemption && (
        <TabItem
          text="Forkjøp"
          icon={<IconTerracedHouse colorVariant="currentColor" />}
          active={false}
          onClick={goToPreemption}
        />
      )}
    </TabBar>
  )
}

export default MobileTabs
